<template>
  <div>
    <navi-header />
    <main role="main">
      <div class="contents-box my-2 py-2">
        <div class="container">
          <room-info />
        </div>
        <step @changeCurrentStep="onStepSelected" />
      </div>
      <welcome v-if="isFirstStep"/>
      <h2 class="contents-title font-weight-bold container mt-3">STEP{{reservationStep}}</h2>
      <div class="contents-box my-2">
        <div class="container pt-3">
          <h3 class="h5 font-weight-bold mb-2">{{flowDetail.title}}</h3>
          <h4 class="h6 font-weight-bold mb-3">{{flowDetail.sub_title}}</h4>
          <div class="step-flow pb-3">
            <p class='u-pre-wrap'>{{flowDetail.text}}</p>
            <div class="image-box mt-5" v-if="flowDetail.image1_url">
              <img :src="flowDetail.image1_url" class="w-100 rounded">
            </div>
            <div class="image-box mt-5" v-if="flowDetail.image2_url">
              <img :src="flowDetail.image2_url" class="w-100 rounded">
            </div>
          </div>
        </div>
      </div>
    </main>
    <navi-footer @goToNextStep="onNextStepSelected" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NaviHeader from '@/components/navi/common/Header'
import RoomInfo from '@/components/navi/common/RoomInfo'
import Step from '@/components/navi/common/Step'
import Welcome from '@/components/navi/common/Welcome'
import NaviFooter from '@/components/navi/common/Footer'
export default {
  name: 'Basic',
  components: { NaviHeader, RoomInfo, Step, NaviFooter, Welcome },
  props: ['flowDetail'],
  data() {
    return {}
  },
  computed: {
    ...mapGetters('reservation', ['reservationStep']),
    ...mapGetters('flowDetails', ['flowDetailsAll']),
    isFirstStep() {
      return this.reservationStep == 1
    },
    isLastStep() {
      return this.flowDetailsAll.length == this.reservationStep
    }
  },
  methods: {
    onNextStepSelected() {
      this.$emit('goToNextStep')
    },
    onStepSelected() {
      this.$emit('setCurrentFlowDetail')
    }
  }
}
</script>

<style scoped>
.u-pre-wrap {
  white-space: pre-wrap;
}
</style>
